"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _canteen = require("@/api/canteen");
var _permission = require("@/utils/permission");
var _addClassify = _interopRequireDefault(require("../components/addClassify.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import ProductType from '../components/productType.vue';
var _default = exports.default = {
  name: 'CanteenCategoryList',
  components: {
    addClassify: _addClassify.default
  },
  data: function data() {
    return {
      showProductTypeDialog: false,
      columnSelectorVisible: false,
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        dictType: "dish:category",
        value: ""
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 关闭弹窗
    closeDialog: function closeDialog() {
      this.showProductTypeDialog = false;
    },
    // 打开列选择器
    handleAddItem: function handleAddItem() {
      this.columnSelectorVisible = !this.columnSelectorVisible;
    },
    // 列选择变化
    handleColumnsChange: function handleColumnsChange() {
      // 可以添加列状态保存逻辑
    },
    handleAdd: function handleAdd(row) {
      var _this = this;
      this.showProductTypeDialog = true;
      this.$nextTick(function () {
        // 统一使用正确的 ref 名称
        var mode = row ? 'edit' : 'add';
        _this.$refs.addClassify.dialogVisible = true;
        _this.$refs.addClassify.openDialog(row, mode);
      });
    },
    handleView: function handleView(row) {
      var _this2 = this;
      this.showProductTypeDialog = true;
      this.$nextTick(function () {
        _this2.$refs.addClassify.openDialog(row, 'view');
      });
    },
    // 删除分类
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      console.log('删除分类', row);
      this.$confirm("\u786E\u5B9A\u5220\u9664\u5206\u7C7B \"".concat(row.value, "\" \u5417\uFF1F"), '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        console.log('删除分类确认删除', row);
        (0, _canteen.dictDataDelete)(row.id).then(function () {
          console.log('删除分类确认删除', row);
          _this3.$message.success('删除成功');
          _this3.getList();
        });
      }).catch(function () {});
    },
    // 搜索
    handleSeachList: function handleSeachList() {
      this.getList(1);
    },
    // 重置搜索
    handleReset: function handleReset() {
      this.tableFrom.name = "";
      this.handleSeachList();
    },
    // 获取分类列表
    getList: function getList(page) {
      var _this4 = this;
      this.listLoading = true;
      if (page) this.tableFrom.page = page;
      console.log('this.tableFrom', this.tableFrom);
      (0, _canteen.dictDataPage)(this.tableFrom).then(function (res) {
        _this4.tableData.data = res.list || [];
        _this4.tableData.total = res.total || 0;
        _this4.listLoading = false;
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    // 分页变化
    pageChange: function pageChange(page) {
      console.log('分页变化', page);
      this.tableFrom.page = page;
      this.getList();
    },
    // 每页数量变化
    handleSizeChange: function handleSizeChange(size) {
      console.log('每页数量变化', size);
      this.tableFrom.limit = size;
      this.getList(1);
    },
    successGetList: function successGetList() {
      this.tableFrom.page = 1;
      this.getList(1);
    }
  }
};